export const LABEL_COLORS = {
  green_light: {
    backgroundColor: '#EEF6EC',
    hoverBackgroundColor: '#D6ECD2',
    foregroundColor: '#B7DDB0',
    hoverForegroundColor: '#7BC86C',
  },
  green: {
    backgroundColor: '#D6ECD2',
    hoverBackgroundColor: '#B7DDB0',
    foregroundColor: '#7BC86C',
    hoverForegroundColor: '#5AAC44',
  },
  green_dark: {
    backgroundColor: '#B7DDB0',
    hoverBackgroundColor: '#99D18F',
    foregroundColor: '#5AAC44',
    hoverForegroundColor: '#49852E',
  },

  yellow_light: {
    backgroundColor: '#FDFAE5',
    hoverBackgroundColor: '#FAF3C0',
    foregroundColor: '#F5EA92',
    hoverForegroundColor: '#F5DD29',
  },
  yellow: {
    backgroundColor: '#FAF3C0',
    hoverBackgroundColor: '#F5EA92',
    foregroundColor: '#F5DD29',
    hoverForegroundColor: '#E6C60D',
  },
  yellow_dark: {
    backgroundColor: '#F5EA92',
    hoverBackgroundColor: '#F3E260',
    foregroundColor: '#E6C60D',
    hoverForegroundColor: '#CCA42B',
  },

  orange_light: {
    backgroundColor: '#FDF4E7',
    hoverBackgroundColor: '#FCE6C6',
    foregroundColor: '#FAD29C',
    hoverForegroundColor: '#FFAF3F',
  },
  orange: {
    backgroundColor: '#FCE6C6',
    hoverBackgroundColor: '#FAD29C',
    foregroundColor: '#FFAF3F',
    hoverForegroundColor: '#E79217',
  },
  orange_dark: {
    backgroundColor: '#FAD29C',
    hoverBackgroundColor: '#FDBF69',
    foregroundColor: '#E79217',
    hoverForegroundColor: '#B4760F',
  },

  red_light: {
    backgroundColor: '#FBEDEB',
    hoverBackgroundColor: '#F5D3CE',
    foregroundColor: '#EFB3AB',
    hoverForegroundColor: '#EF7564',
  },
  red: {
    backgroundColor: '#F5D3CE',
    hoverBackgroundColor: '#EFB3AB',
    foregroundColor: '#EF7564',
    hoverForegroundColor: '#CF513D',
  },
  red_dark: {
    backgroundColor: '#EFB3AB',
    hoverBackgroundColor: '#EC9488',
    foregroundColor: '#CF513D',
    hoverForegroundColor: '#933B27',
  },

  purple_light: {
    backgroundColor: '#F7F0FA',
    hoverBackgroundColor: '#EDDBF4',
    foregroundColor: '#DFC0EB',
    hoverForegroundColor: '#CD8DE5',
  },
  purple: {
    backgroundColor: '#EDDBF4',
    hoverBackgroundColor: '#DFC0EB',
    foregroundColor: '#CD8DE5',
    hoverForegroundColor: '#A86CC1',
  },
  purple_dark: {
    backgroundColor: '#DFC0EB',
    hoverBackgroundColor: '#D5A6E6',
    foregroundColor: '#A86CC1',
    hoverForegroundColor: '#6C547B',
  },

  blue_light: {
    backgroundColor: '#E4F0F6',
    hoverBackgroundColor: '#BCD9EA',
    foregroundColor: '#8BBDD9',
    hoverForegroundColor: '#298FCA',
  },
  blue: {
    backgroundColor: '#BCD9EA',
    hoverBackgroundColor: '#8BBDD9',
    foregroundColor: '#5BA4CF',
    hoverForegroundColor: '#0079BF',
  },
  blue_dark: {
    backgroundColor: '#8BBDD9',
    hoverBackgroundColor: '#5BA4CF',
    foregroundColor: '#026AA7',
    hoverForegroundColor: '#094C72',
  },

  sky_light: {
    backgroundColor: '#E4F7FA',
    hoverBackgroundColor: '#BDECF3',
    foregroundColor: '#8FDFEB',
    hoverForegroundColor: '#29CCE5',
  },
  sky: {
    backgroundColor: '#BDECF3',
    hoverBackgroundColor: '#8FDFEB',
    foregroundColor: '#29CCE5',
    hoverForegroundColor: '#00AECC',
  },
  sky_dark: {
    backgroundColor: '#8FDFEB',
    hoverBackgroundColor: '#5DD3E5',
    foregroundColor: '#00AECC',
    hoverForegroundColor: '#0082A0',
  },

  lime_light: {
    backgroundColor: '#ECFBF3',
    hoverBackgroundColor: '#D3F6E4',
    foregroundColor: '#B3F1D0',
    hoverForegroundColor: '#6DECA9',
  },
  lime: {
    backgroundColor: '#D3F6E4',
    hoverBackgroundColor: '#B3F1D0',
    foregroundColor: '#6DECA9',
    hoverForegroundColor: '#4ED583',
  },
  lime_dark: {
    backgroundColor: '#B3F1D0',
    hoverBackgroundColor: '#90ECC1',
    foregroundColor: '#4ED583',
    hoverForegroundColor: '#49AA54',
  },

  pink_light: {
    backgroundColor: '#FEF1F9',
    hoverBackgroundColor: '#FCDCEF',
    foregroundColor: '#F9C2E4',
    hoverForegroundColor: '#FF8ED4',
  },
  pink: {
    backgroundColor: '#FCDCEF',
    hoverBackgroundColor: '#F9C2E4',
    foregroundColor: '#FF8ED4',
    hoverForegroundColor: '#E568AF',
  },
  pink_dark: {
    backgroundColor: '#F9C2E4',
    hoverBackgroundColor: '#FFABDF',
    foregroundColor: '#E568AF',
    hoverForegroundColor: '#AE4270',
  },

  black_light: {
    backgroundColor: '#EBECF0',
    hoverBackgroundColor: '#DFE1E6',
    foregroundColor: '#505F79',
    hoverForegroundColor: '#42526E',
  },
  black: {
    backgroundColor: '#DFE1E6',
    hoverBackgroundColor: '#C1C7D0',
    foregroundColor: '#344563',
    hoverForegroundColor: '#172B4D',
  },
  black_dark: {
    backgroundColor: '#C1C7D0',
    hoverBackgroundColor: '#B3BAC5',
    foregroundColor: '#091E42',
    hoverForegroundColor: '#000000',
  },
};

export const getLabelHexColor = (groupName, key) => {
  const group = LABEL_COLORS[groupName] || {
    backgroundColor: 'transparent',
    hoverBackgroundColor: 'transparent',
    foregroundColor: 'transparent',
    hoverForegroundColor: 'transparent',
  };

  return key ? group[key] : group;
};
